import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import messages from "../../redux/messages";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
  Breadcrumb,
  ListGroup,
  InputGroup,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";
import CustomNavbar from "../../components/CustomNavbar";
// import SidebarCapacitacion from "../../components/capacitacionDesarrollo/SidebarCapacitacion";
import SidebarDashboard from "../../components/SidebarDashboard";

//redux
import {
  deleteTrainingAssistance,
  editTrainingAssistance,
  getTrainingAssistance,
  saveTrainingAssistance,
  sendCorreoFacilitador,
  sendNotifications,
  sendNotificationsButton,
} from "../../redux/capacitacionDesarrollo/Training_assistance/actions";

import {
  getAllActiveEmployees,
  getAllEmployees,
} from "../../redux/employees/actions";

import { getUsers, resetListUsers } from "../../redux/auth/actions";

import {
  deleteReasonsForAbsence,
  editReasonsForAbsence,
  getReasonsForAbsence,
  saveReasonsForAbsence,
} from "../../redux/capacitacionDesarrollo/reasons_for_absence/actions";

//redux
import {
  getTrainingEventsById,
  getTrainingEvents,
  saveTrainingEvents,
  editTrainingEvents,
  deleteTrainingEvents,
  getEmployeesResponsible,
} from "../../redux/capacitacionDesarrollo/TrainingEvents/actions";
import ModalMaciveEmployeeUpload from "../../components/capacitacionDesarrollo/ModalMaciveEmployeeUpload";

const TrainingAssistance = (props) => {
  const schema = Yup.object().shape({
    recibidas: Yup.string().ensure().notRequired("**Campo requerido"),
    // motivo_inasistencia: Yup.string().ensure().required("**Campo requerido"),
    asistio: Yup.boolean().notRequired(""),
    motivo_inasistencia: Yup.string().when("asistio", {
      is: false,
      then: Yup.string().required("**Campo requerido"),
    }),
  });

  const schemaFacilitador = Yup.object().shape({
    correo: Yup.string().ensure().notRequired("**Campo requerido"),
  });

  // .when("opcion_metrica", (opcion_metrica, schema) => {
  //   if (parseInt(opcion_metrica) !== 3)
  //     return schema.required("**Campo requerido");
  //   return schema;
  // }),

  // Variables de redux
  const { loaderTrainingEvents, loaderpersonResponsible, trainingEvents } =
    useSelector((store) => store.trainingEvents);
  // useEffect(() => {
  //   console.log(trainingEvents);
  // }, [trainingEvents]);

  const {
    loaderTrainingAssistance,
    trainingAssistance,
    trainingAssistanceFail,
    saveLoaderTrainingAssistance,
    trainingAssistanceFormError,
    // trainingAssistanceAll,
    loaderTrainingAssistance_correo_Facilitador,
    trainingAssistance_correo_Facilitador,
    trainingAssistanceAll_correo_Facilitador,
    trainingAssistanceFail_correo_Facilitador,
    saveLoaderTrainingAssistance_correo_Facilitador,
    trainingAssistanceFormError_correo_Facilitador,
  } = useSelector((store) => store.trainingAssistance);

  const { employees, employeesFaild, loaderAllEmployees } = useSelector(
    (store) => store.employees
  );

  const {
    loaderReasonsForAbsence,
    reasonsForAbsence,
    reasonsForAbsenceFail,
    saveLoaderReasonsForAbsence,
    reasonsForAbsenceFormError,
  } = useSelector((store) => store.reasonsForAbsence);

  const [_colaborador, setColaborador] = useState("");

  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showModalEmployees, setShowModalEmployees] = useState(false);
  const [validatedEmployee, setValidatedEmployee] = useState(false);
  const [userSelected, setUserSelected] = useState(null);
  const [showModalUser, setShowModalUser] = useState(false);
  const [showUsers, setShowUsers] = useState("");
  const [_motivos, setMotivos] = useState("");
  const [totalHoras, setTotalHoras] = useState(0);
  const [showModalFacilitador, setShowModalFacilitador] = useState(false);
  const [showModalMaciveUpload, setShowModalMaciveUpload] = useState(false);

  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();

  // const [tipoBusqueda, setTipoBusqueda] = useState({
  //   id: "nombre_capacitacion",
  //   desc: "Capacitación",
  // });
  // const filters = [
  //   { id: "descripcion_capacitacion", desc: "Descripción" },
  //   { id: "nombre_capacitacion", desc: "Nombre" },
  // ];

  const filtersEmployees = [
    { id: "codigo", desc: "Código" },
    { id: "nombre", desc: "Nombre" },
  ];
  const [tipoBusquedaEmployee, setTipoBusquedaEmployee] = useState(
    filtersEmployees[0]
  );
  const pages = Math.ceil(
    trainingAssistance ? trainingAssistance.count / limit : 0
  );

  //Datos custom table
  const columns = [
    {
      Header: "Código",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_empleado[0]
            ? value.row.original.list_empleado[0].codigo
            : null}
        </div>
      ),
    },
    {
      Header: "Nombre completo",
      Filter: "",
      Cell: (value) => <div>{value.row.original.list_empleado[0].nombre}</div>,
    },
    {
      Header: "Asistió",
      Filter: "",
      Cell: (value) => (
        <div>{value.row.original.asistio ? "Asistio" : "No asistio"}</div>
      ),
    },
    {
      Header: "Motivo de inasistencia",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_motivo_inasistencia
            ? value.row.original.list_motivo_inasistencia[0].descripcion
            : ""}
        </div>
      ),
    },
    {
      Header: "Horas recibidas",
      accessor: "recibidas",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.recibidas ? value.row.original.recibidas : "0"}
        </div>
      ),
    },

    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group d-flex" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          {/* {trainingEvents &&
          trainingEvents.campania &&
          trainingEvents.list_campania[0].estado &&
          trainingEvents.list_campania[0].list_estado[0].descripcion.toLowerCase() !==
            "cerrado" ? ( */}
          {trainingEvents &&
          trainingEvents.estado &&
          trainingEvents.list_estado[0].descripcion.toLowerCase() !==
            "cerrado" ? (
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() =>
                onDelete(
                  value.row.original.id,
                  value.row.index,
                  value.row.original.asistio
                )
              }
            >
              <i className="material-icons">close</i>
            </Button>
          ) : null}
        </div>
      ),
    },
  ];

  //methods
  const _getTrainingAssistance = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getTrainingAssistance({
        offset: offs,
        limit: lim,
        tipo_busqueda: "evento_capacitacion__id",
        filter: parseInt(props.match.params.id),
      })
    );

  const onSearchEmployee = (e) => {
    //e.preventDefault();
    if (e.key === "Enter") {
      if (!e.target.value.trim()) {
        setValidatedEmployee(true);
      } else {
        setValidatedEmployee(false);
        dispatch(
          getAllActiveEmployees({
            tipo_busqueda: tipoBusquedaEmployee.id,
            filter: e.target.value,
          })
        );
      }
    }
  };

  const handleUserAdd = (employee, setShowUsers) => {
    setShowUsers("codigo_empleado", employee.id);
    setUserSelected(employee);
    setShowModalUser(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data, asistio) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteTrainingAssistance(id, data, offset, asistio));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getTrainingAssistance(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    // setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getTrainingAssistance(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    // if (
    //   !edit &&
    //   trainingEvents &&
    //   trainingEvents.numero_empleados_recibir <= trainingAssistanceAll.count
    // ) {
    //   toastr.info("La lista de convocados ya se ha llenado");
    //   return;
    // }

    if (
      edit &&
      trainingEvents &&
      trainingEvents.duracion_horas < parseInt(req.recibidas)
    ) {
      toastr.info(
        "La cantidad de horas ingresadas excede la cantidad de horas definidas para el evento"
      );
      return;
    }

    if (!edit && !userSelected) {
      toastr.info("El colaborador aun no a sido seleccionado");
      return;
    }

    // if (
    //   !edit &&
    //   userSelected.id &&
    //   trainingAssistanceAll.data.find((e) => e.empleado === userSelected.id)
    // ) {
    //   toastr.info("El empleado ya está en la lista");
    //   return;
    // }

    // if (req.asistio) {
    //   req.motivo_inasistencia = null;
    // }

    // const req = {};
    let reqAsistio = {};
    if (req.recibidas === "") {
      req.recibidas = null;
    }

    if (!edit) {
      req.empleado = userSelected.id;
      req.evento_capacitacion = parseInt(props.match.params.id);
      req.asistio = false;
      // reqAsistio = {
      //   data: [
      //     {
      //       evento_id: parseInt(props.match.params.idEvento),
      //       tipo_mensaje: "inasistencia Colaborador:Empleado",
      //       codigo_empleado: userSelected.codigo,
      //     },
      //     {
      //       evento_id: parseInt(props.match.params.idEvento),
      //       tipo_mensaje: "inasistencia Colaborador:Jefe",
      //       codigo_empleado: "00500211",
      //     },
      //   ],
      // };
      dispatch(saveTrainingAssistance(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      reqAsistio = {
        data: [
          {
            evento_id: parseInt(props.match.params.id),
            tipo_mensaje: "inasistencia Colaborador:Empleado",
            codigo_empleado: editItem.list_empleado[0].codigo,
          },
          {
            evento_id: parseInt(props.match.params.id),
            tipo_mensaje: "inasistencia Colaborador:Jefe",
            codigo_empleado: editItem.list_empleado[0].codigo,
          },
        ],
      };
      dispatch(
        editTrainingAssistance(
          req,
          index,
          setShowFormModal,
          offset,
          editItem.asistio,
          reqAsistio
        )
      );
    }

    setUserSelected(null);
  };

  const onSubmitFacilitador = (req) => {
    // debugger
    req.id = parseInt(props.match.params.id);
    dispatch(sendCorreoFacilitador(req, setShowModalFacilitador));
  };

  useEffect(() => {
    _getTrainingAssistance();
    dispatch(getReasonsForAbsence());
  }, []);

  useEffect(() => {
    if (props.match.params.id) {
      dispatch(getTrainingEventsById(parseInt(props.match.params.id)));
    }
  }, [props.match.params.id]);

  // useEffect(() => {
  //   let _totalHoras = 0;
  //   trainingAssistanceAll && trainingAssistanceAll.data.map((item) => {
  //     _totalHoras = _totalHoras + item.recibidas;
  //   })
  // }, [trainingAssistanceAll])

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="mb-4 px-2">
            <div className="d-flex flex-wrap justify-content-start align-items-center">
              <Button
                onClick={() => history.goBack()}
                variant="link"
                className="font-weight-bold mr-4 text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
              <Breadcrumb className="pb-0">
                <Breadcrumb.Item
                  title
                  onClick={() =>
                    history.push(`/capacitacion-desarrollo/rutas-capacitacion`)
                  }
                  className="text-uppercase"
                  // onClick={() => history.goBack()}
                >
                  Rutas de capacitación
                </Breadcrumb.Item>

                <Breadcrumb.Item
                  title
                  // onClick={() =>
                  //   history.push(`/descriptores-perfiles/menu-usuario`)
                  // }
                  className="text-uppercase"
                  onClick={() => history.goBack()}
                >
                  Eventos de capactación
                </Breadcrumb.Item>

                <Breadcrumb.Item active title className="text-uppercase">
                  {/* {props.match.params.nombre} */}
                  LISTA DE ASISTENCIA
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <hr className="mx-2" />
          <div className="my-1 pl-md-4 pr-md-3 px-1 d-flex flex-wrap justify-content-between align-items-top">
            <Col className="px-0" md="8">
              <Row>
                <Form.Group as={Col} md={12}>
                  <Row>
                    <Form.Label column sm="auto">
                      <b className="text-black-50">Colaborador:</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Row className="d-flex flex-wrap justify-content-start align-items-center">
                        <Col sm={loaderTrainingAssistance ? "10" : "12"}>
                          <Form.Control
                            className="rounded-pill"
                            readOnly
                            required
                            type="text"
                            value={
                              userSelected
                                ? `${userSelected.codigo} ${userSelected.nombre}`
                                : ""
                            }
                            placeholder="Empleado"
                          ></Form.Control>
                        </Col>
                      </Row>
                    </Col>
                    <ButtonGroup>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Buscar Colaborador</Tooltip>
                        }
                      >
                        <Button
                          variant="light"
                          size="sm"
                          className="rounded-pill my-1"
                          onClick={() => {
                            if (
                              trainingEvents &&
                              trainingEvents.estado &&
                              trainingEvents.list_estado[0].descripcion.toLowerCase() !==
                                "cerrado"
                            ) {
                              setShowModalEmployees(true);
                            }
                          }}
                          disabled={
                            (trainingEvents &&
                              trainingEvents.estado &&
                              trainingEvents.list_estado[0].descripcion.toLowerCase() ===
                                "cerrado") ||
                            loaderTrainingAssistance ||
                            saveLoaderTrainingAssistance
                          }
                        >
                          <i className="material-icons">search</i>
                        </Button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Agregar Colaborador</Tooltip>
                        }
                      >
                        <Button
                          variant="light"
                          size="sm"
                          className="rounded-pill m-1"
                          onClick={() => {
                            if (
                              trainingEvents &&
                              trainingEvents.estado &&
                              trainingEvents.list_estado[0].descripcion.toLowerCase() !==
                                "cerrado"
                            ) {
                              onSubmit({});
                            }
                          }}
                          disabled={
                            (trainingEvents &&
                              trainingEvents.estado &&
                              trainingEvents.list_estado[0].descripcion.toLowerCase() ===
                                "cerrado") ||
                            loaderTrainingAssistance ||
                            saveLoaderTrainingAssistance ||
                            (!edit && !userSelected)
                          }
                        >
                          {saveLoaderTrainingAssistance ||
                          loaderTrainingAssistance ? (
                            <Spinner
                              className="mr-2"
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              align-items="right"
                            />
                          ) : (
                            <i className="material-icons">add</i>
                          )}
                          {/* Agregar */}
                        </Button>
                      </OverlayTrigger>
                    </ButtonGroup>
                  </Row>
                </Form.Group>
              </Row>
            </Col>
            <div>
              <Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col xs="auto">
                  <ButtonGroup>
                    {/* <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill m-1"
                      onClick={() => {
                        if (
                          trainingEvents &&
                          trainingEvents.estado &&
                          trainingEvents.list_estado[0].descripcion.toLowerCase() !==
                            "cerrado"
                        ) {
                          onSubmit({});
                        }
                      }}
                      disabled={
                        (trainingEvents &&
                          trainingEvents.estado &&
                          trainingEvents.list_estado[0].descripcion.toLowerCase() ===
                            "cerrado") ||
                        loaderTrainingAssistance ||
                        saveLoaderTrainingAssistance
                      }
                    >
                      {saveLoaderTrainingAssistance ||
                      loaderTrainingAssistance ? (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          align-items="right"
                        />
                      ) : (
                        <i className="material-icons">add</i>
                      )}
                      Agregar
                    </Button> */}
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Enviar convocatoria</Tooltip>
                      }
                    >
                      <Button
                        className="rounded-pill"
                        style={{ cursor: "pointer" }}
                        variant="secondary"
                        type="button"
                        onClick={() => {
                          dispatch(
                            sendNotificationsButton({
                              id: parseInt(props.match.params.id),
                            })
                          );
                        }}
                        disabled={
                          loaderTrainingAssistance ||
                          saveLoaderTrainingAssistance ||
                          (trainingEvents &&
                            trainingEvents.estado &&
                            trainingEvents.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado")
                        }
                      >
                        {saveLoaderTrainingAssistance ||
                        loaderTrainingAssistance ? (
                          <Spinner
                            className="mr-2"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            align-items="right"
                          />
                        ) : null}
                        Enviar
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Enviar correo facilitador</Tooltip>
                      }
                    >
                      <Button
                        className="rounded-pill  mx-1"
                        style={{ cursor: "pointer" }}
                        variant="secondary"
                        type="button"
                        onClick={() => setShowModalFacilitador(true)}
                        disabled={
                          loaderTrainingAssistance ||
                          saveLoaderTrainingAssistance ||
                          (trainingEvents &&
                            trainingEvents.estado &&
                            trainingEvents.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado")
                        }
                      >
                        {saveLoaderTrainingAssistance ||
                        loaderTrainingAssistance ? (
                          <Spinner
                            className="mr-2"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            align-items="right"
                          />
                        ) : null}
                        Facilitador
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>
                          Cargar listado colaboradores
                        </Tooltip>
                      }
                    >
                      <Button
                        className="rounded-pill"
                        style={{ cursor: "pointer" }}
                        variant="secondary"
                        type="button"
                        onClick={() => setShowModalMaciveUpload(true)}
                        disabled={
                          loaderTrainingAssistance ||
                          saveLoaderTrainingAssistance ||
                          loaderTrainingEvents ||
                          (trainingEvents &&
                            trainingEvents.estado &&
                            trainingEvents.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado")
                        }
                      >
                        {saveLoaderTrainingAssistance ||
                        loaderTrainingAssistance || 
                        loaderTrainingEvents ? (
                          <Spinner
                            className="mr-2"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            align-items="right"
                          />
                        ) : null}
                        Cargar
                      </Button>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Row>
            </div>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 text-uppercase">
             F-399v4 {trainingEvents ? trainingEvents.nombre_evento_capacitacion : ""}
            </h5>
            <div>
              <Row className="d-flex justify-content-sm-end align-items-center flex-wrap">
                <Col xs="auto">
                  <InputGroup>
                    <InputGroup.Text id="basic-addon2" className="rounded-pill">
                      Total asistencias:{" "}
                      {trainingAssistance
                        ? trainingAssistance.asistencia_total
                        : null}
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
                <Col xs="auto">
                  <InputGroup>
                    <InputGroup.Text
                      id="basic-addon1"
                      className="rounded-pill mt-0"
                    >
                      Total inasistencias:{" "}
                      {trainingAssistance
                        ? trainingAssistance.inasistencia_total
                        : null}
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
              </Row>
            </div>
          </div>
          {/* <Row>
            <Col md="7">
              <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                <h5 className="text-black-50 m-0 text-uppercase">
                  {trainingEvents
                    ? trainingEvents.nombre_evento_capacitacion
                    : ""}
                </h5>
              </div>
            </Col>
            <Col
              md="2"
              className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center"
            >
              <InputGroup>
                <InputGroup.Text id="basic-addon2" className="rounded-pill">
                  Total asistencias:{" "}
                  {trainingAssistance
                    ? trainingAssistance.asistencia_total
                    : null}
                </InputGroup.Text>
              </InputGroup>
            </Col>
            <Col
              md="2"
              className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center"
            >
              <InputGroup>
                <InputGroup.Text
                  id="basic-addon1"
                  className="rounded-pill mt-0"
                >
                  Total inasistencias:{" "}
                  {trainingAssistance
                    ? trainingAssistance.inasistencia_total
                    : null}
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Row> */}

          {!!trainingAssistanceFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {trainingAssistanceFail}
            </Alert>
          )}
          {!loaderTrainingEvents &&
            trainingEvents &&
            trainingEvents.estado &&
            trainingEvents.list_estado[0].descripcion.toLowerCase() ===
              "cerrado" && (
              <Alert variant="info" className="mt-4 mb-1 mx-3">
                No se puede editar ya que el evento ha finalizado
              </Alert>
            )}
          {loaderTrainingAssistance || loaderTrainingEvents ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : trainingAssistance != null &&
            trainingAssistance.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable
                    columns={columns}
                    data={trainingAssistance.data}
                  />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={trainingAssistance.count}
                pages={pages}
                pagFunc={_getTrainingAssistance}
              />
            </>
          ) : (
            <>
              {trainingEvents &&
                trainingEvents.estado &&
                trainingEvents.list_estado[0].descripcion.toLowerCase() !==
                  "cerrado" && (
                  <Alert variant="info" className="mt-4 mb-1 mx-3">
                    Aún no hay registros, comience creando algunos.
                  </Alert>
                )}
            </>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              // descripcion_capacitacion: edit
              //   ? editItem.descripcion_capacitacion
              //   : "",
              recibidas: edit ? editItem.recibidas : "",
              motivo_inasistencia: edit
                ? editItem.motivo_inasistencia
                  ? editItem.motivo_inasistencia
                  : ""
                : "",
              asistio: edit
                ? editItem.asistio
                  ? editItem.asistio
                  : false
                : false,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit
                      ? "Editar Asistencia a capacitación"
                      : "Crear Asistencia a capacitación"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {trainingAssistanceFormError &&
                  typeof trainingAssistanceFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {trainingAssistanceFormError}
                    </Alert>
                  ) : null}

                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Horas recibidas
                    </Form.Label>
                    <Form.Control
                      name="recibidas"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.recibidas}
                      placeholder="Horas"
                      onBlur={handleBlur("recibidas")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.recibidas && !!errors.recibidas}
                      disabled={
                        // trainingEvents &&
                        // trainingEvents.campania &&
                        // trainingEvents.list_campania[0].estado &&
                        // trainingEvents.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                        //   "cerrado"
                        trainingEvents &&
                        trainingEvents.estado &&
                        trainingEvents.list_estado[0].descripcion.toLowerCase() ===
                          "cerrado"
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.recibidas}
                    </Form.Control.Feedback>
                    {trainingAssistanceFormError &&
                    typeof trainingAssistanceFormError === "object" &&
                    trainingAssistanceFormError.recibidas ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {trainingAssistanceFormError.recibidas.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mx-2 my-3">
                    <div className="d-flex aling-items-center justify-content pt-3">
                      <label htmlFor="asistio" className="px-2">
                        Asistió
                      </label>
                      <Form.Check
                        id="asistio"
                        name="asistio"
                        isInvalid={touched.asistio && errors.asistio}
                        isValid={touched.asistio && !errors.asistio}
                        onBlur={handleBlur("asistio")}
                        onChange={(e) => {
                          setFieldValue("asistio", e.target.checked);
                        }}
                        value={values.asistio}
                        className="rounded-pill"
                        type="switch"
                        defaultChecked={
                          edit
                            ? editItem.asistio
                              ? editItem.asistio
                              : false
                            : false
                        }
                        disabled={
                          // trainingEvents &&
                          // trainingEvents.campania &&
                          // trainingEvents.list_campania[0].estado &&
                          // trainingEvents.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                          //   "cerrado"
                          trainingEvents &&
                          trainingEvents.estado &&
                          trainingEvents.list_estado[0].descripcion.toLowerCase() ===
                            "cerrado"
                        }
                      />
                      {touched.asistio && errors.asistio && (
                        <div className="px-2">
                          <small className="text-danger">
                            {errors.asistio}
                          </small>
                        </div>
                      )}
                    </div>
                  </Form.Group>

                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Motivo de inasistencia
                    </Form.Label>

                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loaderReasonsForAbsence ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="motivo_inasistencia"
                          name="motivo_inasistencia"
                          className="col rounded-pill"
                          // defaultValue=""
                          isInvalid={
                            touched.motivo_inasistencia &&
                            errors.motivo_inasistencia
                          }
                          isValid={
                            touched.motivo_inasistencia &&
                            !errors.motivo_inasistencia
                          }
                          onBlur={handleBlur("motivo_inasistencia")}
                          // onChange={(e) => {
                          //   setFieldValue("asistio", e.target.checked);
                          // }}
                          value={values.motivo_inasistencia}
                          // disabled={values.asistio}
                          disabled={
                            // trainingEvents &&
                            // trainingEvents.campania &&
                            // trainingEvents.list_campania[0].estado &&
                            // trainingEvents.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                            //   "cerrado"
                            trainingEvents &&
                            trainingEvents.estado &&
                            trainingEvents.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado"
                          }
                          onChange={(e) => {
                            e.preventDefault();
                            // setFilter(e.currentTarget.value);
                            // setMotivos(e.currentTarget.value);
                            setFieldValue(
                              "motivo_inasistencia",
                              e.currentTarget.value
                            );
                            // setEmpresa(e.currentTarget.value);
                            // dispatch(
                            //   getPeriodicity({
                            //     tipo_busqueda: "empresa__id",
                            //     filter: parseInt(e.currentTarget.value),
                            //   })
                            // );
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            // disabled
                          >
                            Selecionar motivo inasistencia
                          </option>
                          {reasonsForAbsence &&
                            reasonsForAbsence.data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.descripcion}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loaderReasonsForAbsence ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  {/* {trainingEvents &&
                  trainingEvents.campania &&
                  trainingEvents.list_campania[0].estado &&
                  trainingEvents.list_campania[0].list_estado[0].descripcion.toLowerCase() !==
                    "cerrado" ? ( */}
                  {trainingEvents &&
                  trainingEvents.estado &&
                  trainingEvents.list_estado[0].descripcion.toLowerCase() !==
                    "cerrado" ? (
                    <Button
                      className="rounded-pill"
                      disabled={saveLoaderTrainingAssistance}
                      variant="primary"
                      type="submit"
                    >
                      {saveLoaderTrainingAssistance && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </Button>
                  ) : null}
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>

        <Modal
          show={showModalEmployees}
          onHide={() => setShowModalEmployees(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Buscar Colaborador</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="justify-content-end align-items-center flex-nowrap">
              <Col xs="auto">
                <Form.Label className="m-0" htmlFor="filterEmployee">
                  <b>{tipoBusquedaEmployee.desc}:</b>
                </Form.Label>
              </Col>
              <Col xs="auto">
                <Form.Control
                  id="filterEmployee"
                  name="filterEmployee"
                  // placeholder="Buscar Colaborador"
                  required
                  className={`rounded-pill form-control-sm ${
                    validatedEmployee ? "is-invalid" : ""
                  }`}
                  type="search"
                  onKeyDown={onSearchEmployee}
                  //value={searchEmployee}
                  //onChange={e => setSearchEmployee(e.target.value)}
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
              <Col>
                <ButtonGroup>
                  <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip {...props}>Seleccionar Filtrado</Tooltip>}
                  >
                    <Dropdown className="ml-3 mr-3">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filtersEmployees.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusquedaEmployee(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </OverlayTrigger>
                </ButtonGroup>
              </Col>
            </Row>
            <div className="my-3">
              {employeesFaild ? (
                <Alert variant="error" className="my-4">
                  {employeesFaild}
                </Alert>
              ) : null}
              {loaderAllEmployees ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : employees.length > 0 ? (
                <ListGroup variant="flush">
                  {employees.map((employee) => (
                    <ListGroup.Item className="d-flex flex-wrap justify-content-between align-items-center">
                      <p className="m-0">
                        {employee.codigo} {employee.nombre}
                      </p>
                      <Button
                        onClick={() => {
                          handleUserAdd(employee, setShowUsers);
                          dispatch(getUsers({ filter: employee.codigo }));
                          setShowModalEmployees(false);
                        }}
                        size="sm"
                        variant="primary"
                        className="rounded-circle"
                      >
                        <i className="material-icons">person_add</i>
                      </Button>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              ) : (
                <Alert variant="info" className="my-4">
                  Sin registros que mostrar.
                </Alert>
              )}
            </div>
          </Modal.Body>

          {/* <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowFormModal(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={saveLoaderTrainingAssistance}
              variant="primary"
              type="submit"
            >
              {saveLoaderTrainingAssistance && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Guardar
            </Button>
          </Modal.Footer> */}
        </Modal>

        <Modal
          show={showModalFacilitador}
          onHide={() => setShowModalFacilitador(false)}
        >
          <Formik
            validationSchema={schemaFacilitador}
            onSubmit={onSubmitFacilitador}
            initialValues={{
              correo: "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              setFieldValue,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="text-muted">
                    Enviar correo
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {!!trainingAssistanceFormError_correo_Facilitador && (
                    <Alert variant="danger" className="mt-1 mb-2">
                      {trainingAssistanceFormError_correo_Facilitador}
                    </Alert>
                  )}
                  <Row>
                    <Form.Group as={Col}>
                      <Row className="align-items-end">
                        <Col>
                          <Form.Label className="ml-2">Correo</Form.Label>
                          <Form.Control
                            id="correo"
                            name="correo"
                            isInvalid={touched.correo && errors.correo}
                            isValid={touched.correo && !errors.correo}
                            onBlur={handleBlur("correo")}
                            onChange={handleChange}
                            value={values.correo}
                            type="text"
                            className="rounded-pill"
                            // disabled={
                            //   edit &&
                            //   // editItem.campania &&
                            //   // editItem.list_campania[0].estado &&
                            //   // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                            //   //   "cerrado"
                            //   editItem.estado &&
                            //   editItem.list_estado[0].descripcion.toLowerCase() ===
                            //     "cerrado"
                            // }
                          />
                          {touched.correo && !!errors.correo && (
                            <div className="px-2">
                              <small className="text-danger">
                                {errors.correo}
                              </small>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowModalFacilitador(false)}
                  >
                    Cerrar
                  </Button>
                  {/* {editItem.estado && ( */}
                  <>
                    <Button
                      className="rounded-pill"
                      disabled={saveLoaderTrainingAssistance_correo_Facilitador}
                      variant="primary"
                      type="submit"
                      // onClick={() => dispatch(
                      //   sendCorreoFacilitador(
                      // ))}
                    >
                      {saveLoaderTrainingAssistance_correo_Facilitador && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      {/* {editItem.list_tipo_evaluacion[0].nombre === "90°"
                        ? "Aceptar"
                        : "Guardar"} */}
                      Enviar
                    </Button>
                  </>
                  {/* // )} */}
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>

        <ModalMaciveEmployeeUpload
          setShowModalMaciveUpload={setShowModalMaciveUpload}
          showModalMaciveUpload={showModalMaciveUpload}
          id={parseInt(props.match.params.id)}
          motivos={reasonsForAbsence ? reasonsForAbsence.data : []}
          getTrainingAssistance={_getTrainingAssistance}
          loaderTrainingAssistance={loaderTrainingAssistance}
        />
        {/*Modal*/}
      </div>
    </>
  );
};

export default TrainingAssistance;
